import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { BRAND } from "@/lib/brand";

/**
 * GenAICore mark: an open-ring "G" (the gateway) around a lime core where
 * traffic converges. Drawn on a near-black tile; a hairline edge keeps the
 * tile visible on dark surfaces.
 */
export function LogoMark({ className, title = BRAND.name }: { className?: string; title?: string }) {
  return (
    <svg viewBox="0 0 32 32" role="img" aria-label={title} className={cn("h-8 w-8 shrink-0", className)}>
      <rect width="32" height="32" rx="9" fill="#111111" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="8.5" fill="none" className="stroke-transparent dark:stroke-white/15" />
      <path
        d="M22.4 10.4 A8.4 8.4 0 1 0 24.4 16.6 H18.6"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="15.4" cy="16.4" r="2.5" fill="hsl(var(--brand))" />
    </svg>
  );
}

/** Wordmark: "GenAICore." in full contrast, product name muted. */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn("text-[19px] font-bold tracking-[-0.02em] leading-none whitespace-nowrap", className)}>
      {BRAND.company}
      <span className="text-brand-strong">.</span>
      <span className="text-muted-foreground font-medium text-[16px] ml-1">{BRAND.product}</span>
    </span>
  );
}

interface BrandLockupProps {
  compact?: boolean;
  to?: string;
  className?: string;
  /** Extra element after the wordmark (e.g. a "Docs" pill). */
  suffix?: React.ReactNode;
}

/** Linked logo lockup used by the sidebar, auth pages, landing and docs. */
export function BrandLockup({ compact = false, to = "/dashboard", className, suffix }: BrandLockupProps) {
  return (
    <Link to={to} className={cn("flex items-center gap-2.5 select-none", className)} aria-label={`${BRAND.name} home`}>
      <LogoMark />
      {!compact && <Wordmark />}
      {!compact && suffix}
    </Link>
  );
}
